import { Address, Contract, MyProfileData, ProductTypeEN, isCustomerType } from 'cpfr-common';
import React from 'react';
import { NoConnectionNotification } from '../../notifications/no-connection/NoConnectionNotification';
import { AddressSection, isEmptyAddress } from '../address-section/AddressSection';
import { ContactDetailsCheckPendingNotification } from '../address-section/contact-details-change-pending-notification/ContactDetailsCheckPendingNotification';
import { ContactSection } from '../contact-section';
import { IdentificationSection, isEmptyIdentification } from '../identification-section';
import { MarketingSettingsSection } from '../marketing-settings-section/MarketingSettingsSection';

export const MyProfileUi: React.FC<{
    myProfileData?: MyProfileData;
    contracts?: Contract[];
    isContactInformationChangePending: boolean;
    isNameChangePending: boolean;
    isAddressChangePending: boolean;
}> = ({ myProfileData, contracts, isContactInformationChangePending, isNameChangePending, isAddressChangePending }) => {
    if (!myProfileData) {
        return null;
    }

    const { identification, contactDetails, address, billingAddress, marketingSettings, notification } = myProfileData;
    const isEligibleNpaiNotification = myProfileData?.identification?.data.isEligibleNpaiNotification;
    // if there's no error we can assume at least empty profile data object

    if (isEmptyIdentification(identification) && isEmptyAddress(address))
        // isEmptyContact(contactDetails)
        return <NoConnectionNotification />;

    const hasLVDL_PRContracts = (): boolean => {
        const LVDL_PRContracts = contracts
            ? contracts.filter((contract) => contract.isActive && contract.productType === 'LVDL_PR')
            : [];
        return LVDL_PRContracts.length > 0;
    };

    const customerType: isCustomerType = {
        isPrivateCustomer: identification?.customerType === 'Retail',
        isPMCustomer: identification?.customerType === 'PM',
    };

    const getBillingAddress = (): Address | undefined => {
        const isBillingAddressEqualToPostal = JSON.stringify(billingAddress) === JSON.stringify(address);
        return customerType.isPrivateCustomer || isBillingAddressEqualToPostal ? {} : billingAddress;
    };

    const hasBallonContracts = (): boolean => {
        const ballonContracts = contracts
            ? contracts.filter(
                  (contract) => contract.isActive && contract.productTypeEN === ProductTypeEN.BALLON_LEASING,
              )
            : [];
        return ballonContracts.length > 0;
    };

    return (
        <>
            <div className={'u-mb'}>
                {isContactInformationChangePending && <ContactDetailsCheckPendingNotification />}
                <IdentificationSection
                    identification={identification}
                    isNameChangePending={isNameChangePending}
                    isContactInformationChangePending={isContactInformationChangePending}
                />
                <AddressSection
                    address={address}
                    billingAddress={getBillingAddress()}
                    customerType={customerType}
                    hasBallonContracts={hasBallonContracts()}
                    hasLVDL_PRContracts={hasLVDL_PRContracts()}
                    isAddressChangePending={isAddressChangePending}
                    isPostalAddressChangePending={
                        customerType.isPrivateCustomer
                            ? !!notification?.addressChange
                            : !!notification?.companyAddressChange
                    }
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    isBillingAddressChangePending={!!(notification as any)?.billingAddressChange}
                    isContactInformationChangePending={isContactInformationChangePending}
                    isEligibleNpaiNotification={!!isEligibleNpaiNotification}
                />
                <ContactSection
                    contactDetails={contactDetails}
                    isContactInformationChangePending={isContactInformationChangePending}
                />
                <MarketingSettingsSection marketingSettings={marketingSettings} />
            </div>
        </>
    );
};
